import { ComponentDataDestService } from '../component-data-dest.service';
import { environment } from '../../../environment/environment';
import { EventDTO } from '../../../dto/event/event.dto';
import { Observable, catchError, tap } from 'rxjs';
import { Router } from '@angular/router';

export function unlinkEventFromGroup(
  service: ComponentDataDestService,
  eventGuid?: string
): Observable<EventDTO> {
  const router = service.injector.get(Router);
  const guid =
    eventGuid ||
    router.url.split('/').find((segment: string) =>
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment)
    );

  if (!guid) {
    throw new Error('Ingen gyldig event-GUID fundet');
  }

  const url = `${environment.apiUrl}/events/${guid}/unlink-from-group`;

  return service.http.post<EventDTO>(url, {}).pipe(
    catchError((error) => {
      console.error('[unlink_event_from_group] Error:', error);
      const message =
        error?.error?.message || error?.message || 'Kunne ikke løsrive eventet fra gruppen';
      throw new Error(message);
    })
  );
}

export const unlink_event_from_group = (
  service: ComponentDataDestService,
  data?: { event_guid?: string }
) => unlinkEventFromGroup(service, data?.event_guid);
